<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <div class="d-flex justify-content-between">
          <h5 style="font-size: 1.3vw !important;">واحد های کسب و کار/{{title_route}}</h5>
          <button class="btn btn-primary btn-submit-1" style="width: 4vw !important;" @click="$router.go(-1)">برگشت</button>


        </div>
        <hr v-if="false">
        <center class="mt-3 mb-3" v-if="false">
          <div class="d-flex col-12">
            <div class="d-flex flex-column col-4">
              <label> عنوان </label>
              <input v-model="title" type="text" class="form-control">
            </div>
            <div class="d-flex flex-column col-4 mx-2">
              <label> پست های سازمان </label>
              <input @click.prevent="fetchUsers" type="text" class="form-control"
                     placeholder="انتخاب از پست های سازمانی"
                     v-model="names_organs"
                     :readonly="true">
            </div>
            <div style=" transform: translateY(1.7vw) translateX(-2vw)" class="d-flex">
              <button v-if="IsEdit" @click.prevent="update(item_id)" class="btn btn-primary btn-submit-1"
                      style="width: 5vw !important;">ویرایش
              </button>
              <button v-else @click.prevent="store" class="btn btn-primary btn-submit-1" style="width: 5vw !important;">
                افزودن
              </button>
              <Reset @click.prevent="reset" style="width: 1.7vw; height: 1.7vw;" class="mx-1"/>
            </div>

          </div>
        </center>
        <hr>

        <table v-if="items.length" class="table table-striped mt-4">
          <thead>
          <tr>
            <th style="width: 1vw;">ردیف</th>
            <th>عنوان</th>
            <th>پست های سازمانی</th>
            <th v-if="false" style="width: 5vw;">عملیات</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in items">
            <td>{{ index + 1 }}</td>
            <td class="text-end">{{ item.title }}</td>
            <td class="text-end">
              <div v-if="item.organization_posts">
                <span v-for="(ele,index) in item.organization_posts" :key="index">{{ ele.name }} <span
                    v-if="item.organization_posts[index+1]">/</span></span>
              </div>
            </td>
            <td v-if="false">
              <div class="d-flex" style="height: 1vw !important; width: 4vw;">
                <p style="width: 2vw;" @click.prevent="deleteModalMethod(item.id)" href="#"><img
                    class="table-delete-img mx-2" src="/img/delete.f9fc94bc.svg" alt="delete"></p>
                <a style="width: 2vw; transform: translateX(-0.2vw)" @click.prevent="edit(item.id)" href="#"><img
                    class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>
              </div>
            </td>
          </tr>

          </tbody>
        </table>
        <center v-else class="mt-4">
          <p>
            موردی یافت نشد!
          </p>
        </center>

      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="select_curator" style="z-index: 999999999999999">
    <div>
      <p>انتخاب متصدی</p>
      <p @click="select_curator=!select_curator">❌</p>
    </div>
    <div>
      <input v-model="search_curator" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس پست سازمانی  ...">
      <div style="overflow-y:scroll; width: 100%; height: 10vw;">

        <table class="table table-striped">
          <thead>
          <tr>
            <th style="width: 1vw;">انتخاب</th>
            <th>پست سازمانی</th>
          </tr>
          </thead>
          <tbody v-for="(item, index) in filteredCurator" :key="item.id">
          <tr>
            <td scope="row"><input :id="`item_${item.id}`" v-model="curatorId" type="checkbox" :value="item['id']"></td>
            <td>
              <label :for="`item_${item.id}`">
                {{ item['name'] }}
              </label>
            </td>
          </tr>

          </tbody>
        </table>
      </div>
      <div class="d-flex">
        <button class="btn btn-submit-1 btn-primary mx-2" @click="select_curator=!select_curator">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 55%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="submit_delete(item_id)">تایید</button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";
import Reset from "@/components/Icons/Reset.vue";
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
  name: 'HomeView',
  components: {
    Reset,
    Sidebar,
    splash
  },
  data() {
    return {
      curatorId: [],
      all_curator: [],
      items: [],
      names_organs: [],
      search_curator: '',
      title: '',
      item_id: '',
      select_curator: false,
      IsEdit: false,
      deleteModal: false,
      id_route: this.$route['params']['id'],
      title_route: this.$route['params']['title'],

    }
  },
  methods: {
    reset() {
      this.names_organs.length = 0
      this.curatorId.length = 0
      this.title = ''
      this.id = ''
      this.IsEdit = false
    },
    store() {
      if (!this.title.length) {
        toast.error('عنوان اجباری است!')
        return;
      } else if (this.curatorId.length === 0) {
        toast.error('حداقل یک پست سازمانی  اجباری است!')
        return;
      }
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      const raw = JSON.stringify({
        "title": this.title,
        "organizationPosts": [
          ...this.curatorId
        ]
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

      fetch(`${this.base_url}/businessUnit`, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.error) {
              toast.success(result.error)
              return
            }
            if (result.message) {
              toast.success(result.message)
              this.all()
              this.reset()
            }
          })
          .catch((error) => console.error(error));
    },
    submit_delete(id) {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      const requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        redirect: "follow"
      };

      fetch(`${this.base_url}/businessUnit/${id}`, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.message) {
              this.all()
              toast.success(result.message)
            }
          })
          .catch((error) => console.error(error));
      this.deleteModal = false
      this.item_id = ''


    },
    deleteModalMethod(id) {
      this.deleteModal = true
      this.item_id = id
    },
    edit(id) {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
      };

      fetch(`${this.base_url}/businessUnit/${id}`, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.data) {
              this.title = result.data.title
              this.item_id = result.data.id
              this.names_organs.length = 0
              if (result.data.organizationPosts) {
                result.data.organizationPosts.forEach((item) => {
                  this.curatorId.push(item.id)
                  this.names_organs.push(item.name + '...')

                })
              }
              this.IsEdit = true
            }
          })
          .catch((error) => console.error(error));
    },
    update(id) {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      const raw = JSON.stringify({
        "title": this.title,
        "organizationPosts": [
          ...this.curatorId
        ]
      });

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

      fetch(`${this.base_url}/businessUnit/${id}`, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result) {
              this.reset()
              this.all()
            }
          })
          .catch((error) => console.error(error));
    },
    showItems(data) {

    },
    all() {
      this.items.length = 0
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow"
      };

      fetch(`${this.base_url}/businessUnit/mother/${this.id_route}`, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.data) {
              result.data.forEach((item) => {
                this.items.push(item)
              })

            }
          })
          .catch((error) => {
            toast.error(error)
          });
    },

    checkIsMother() {
      if (!this.is_mother) {
        router.push('/pishkhan')
      }

    },
    fetchUsers() {
      this.all_curator.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/organization/post/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result['all']) {
              result.all.forEach((item) => {
                this.all_curator.push(item)
              })
              if (this.all_curator.length) {
                this.select_curator = true
              }

            }

          })
          .catch();
    },

  },
  mounted() {
    this.all()
    this.checkIsMother()
  },
  watch: {
    curatorId: function (newVal, old) {
      this.names_organs.length = 0

      this.all_curator.forEach((ele) => {
        parseInt(ele.id) === parseInt(newVal) ? this.names_organs.push(ele.name + '...') : ''
      })
    }
  },
  computed: {
    filteredCurator() {
      return this.all_curator.filter(item => {
        return (

            item['name'] && item['name'].includes(this.search_curator)
        );
      });
    },
  }
}
</script>
<style scoped lang="scss">
a {
  font-size: 1vw;
}

.card:not(:last-child) {
  height: 12vw;
}

.btn-submit-1 {
  width: 18vw !important;
}

/*.line_after{
  position: relative;
  &::after{
    position: absolute;
    width: 0.01vw;
    height: 53vw;
    content: '';
    background-color: #efecf3 !important;
    top: 5vw;
    right: 35.3vw ;
    border-radius: 1vw;
  }
}*/
</style>